import script from "./BillConnectionProject.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillConnectionProject.vue?vue&type=script&setup=true&lang=ts"

import "./BillConnectionProject.vue?vue&type=style&index=0&id=3c9bf672&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9bf672"]])

export default __exports__